if (__app.site.disqus.shortname && __app.site.disqus.shortname !== '' && __app.page.comments === true) {
    let disqus_config = function () {
        this.page.url = __app.page.url;
        this.page.identifier = __app.page.url;
    };
    (function () {
        let d = document, s = d.createElement('script');
        s.src = 'https://' + __app.site.disqus.shortname + '.disqus.com/embed.js';
        s.setAttribute('data-timestamp', +new Date());
        (d.head || d.body).appendChild(s);
    })();
}



// WEBPACK FOOTER //
// ./src/_assets/js/disqus_comments.js